<ng-container [formGroup]="form">
	<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px">
		<rpshared-select-list
			required
			formControlName="billTo"
			placeholder="Bill To"
			[items]="billTos"
			(selectionChange)="setBillTo($event.value)"
		></rpshared-select-list>
		<rpshared-select-list
			required
			formControlName="preferredBillingChannel"
			placeholder="Bill Via"
			[items]="billVias"
			(selectionChange)="setBillVia($event.value)"
		></rpshared-select-list>
	</div>

	<ng-container [ngSwitch]="billVia$ | async">
		<ng-container *ngSwitchCase="'Email'">
			<ng-container [ngSwitch]="billTo$ | async">
				<ng-container *ngSwitchCase="'Other'">
					<rpshared-multi-chip-input gdColumn="1 / -1" placeholder="Billing Emails"
						formControlName="billingEmails">
					</rpshared-multi-chip-input>
				</ng-container>
				<ng-container *ngSwitchCase="'Railroad'">
					<rpshared-multi-chip-input [defaultIfEmpty]="railroad?.billingEmail" gdColumn="1 / -1"
						placeholder="Railroad Billing Emails" formControlName="billingEmails">
					</rpshared-multi-chip-input>
				</ng-container>
				<ng-container *ngSwitchCase="'Customer'">
					<rpshared-multi-chip-input [defaultIfEmpty]="customer?.billingEmail" gdColumn="1 / -1"
						placeholder="Customer Billing Emails" formControlName="billingEmails">
					</rpshared-multi-chip-input>
				</ng-container>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="'Mail'">
		</ng-container>
		<ng-container *ngSwitchCase="'Portal'">
		</ng-container>
	</ng-container>

	<ng-container [ngSwitch]="billTo$ | async">
		<ng-container *ngSwitchCase="'Other'">
			<rpshared-billing-company formControlName="otherBillingCompany"></rpshared-billing-company>
		</ng-container>
		<ng-container *ngSwitchCase="'Railroad'">
			<rpshared-billing-company-readonly [company]="railroad"></rpshared-billing-company-readonly>
		</ng-container>
		<ng-container *ngSwitchCase="'Customer'">
			<rpshared-billing-company-readonly [company]="customer" [allowAddressSelection]="true"
				[currentBillingAddressId]="form.get('billingAddress').value?.id"
				(addressSelected)="onBillingAddressSelected($event)"></rpshared-billing-company-readonly>
		</ng-container>
	</ng-container>

	<mat-form-field class="w-100">
		<textarea matInput maxlength="300" cdkTextareaAutosize cdkAutosizeMinRows="1" placeholder="Notes"
			formControlName="billingNotes">
		</textarea>
	</mat-form-field>
</ng-container>